import type { BankProductFormInput } from "web_myplann/Portfolio/Forms/BankProductForm/bankProductFormSchema";

export const BANK_PRODUCT_FORM_DEFAULT_VALUES: BankProductFormInput = {
	name: "",
	producer: "",
	product: "",
	contractNumber: "",
	productCategoryId: null,
	signedAt: null,
	startAt: null,
	endAt: null,
};
